<template>
    <div class="article">
        <div class="article-container">
            <div class="article-title">
                <div class="name-wrapper">
                    <h3>성적표</h3>
                </div>
            </div>
            <div class="article-demonstrate">
                <li class="demonstration">회원님의 선생님이 입력한 채점 결과입니다.</li>
                <li class="average">평균:{{ this.average }}</li>
            </div>
            <div class="article-table">
                <template>
                    <el-table
                            :data="tableData"
                            size="small"
                            empty-text="채점결과가 없습니다.">
                        <el-table-column
                                prop="chapter"
                                width="280"
                                label="대단원">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                width="330"
                                label="소단원">
                        </el-table-column>
                        <el-table-column
                                prop="score"
                                width="100"
                                label="점수">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                width="170"
                                label="채점 날짜">
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="pagination">
                <el-pagination
                        layout="prev, pager, next"
                        @current-change="pagination"
                        :total="listCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "score.vue",
        data() {
            return {
                listCount: 0,
                tableData: null
            }
        },
        mounted() {
            this.$http.defaults.headers['x-access-token'] = this.token;
            this.$http.get('/api/score/list')
            .then((result) => {
                this.tableData = result.data;
                this.tableData.map(r => r.date = r.date.split('T')[0])
            })
            .catch((err) => {
                console.log(err);
            })
        },
        methods: {
            getList(page) {
                this.$http.get(`/api/article/${this.type}/list/${page}`)
                    .then((result) => {
                        this.tableData = result.data;
                        this.tableData = this.tableData.filter(n => n);
                        this.tableData.map(x => x.date = x.date.split('T')[0]);
                    })
            },
            pagination(page) {
                this.getList(page);
            }
        },
        computed: mapGetters({
            average: "getAverage",
            token: "getToken"
        })
    }
</script>

<style scoped>
    .score-title {
        width: 100%;
        border-bottom: 2px solid #bcbcbc;
        margin: 0 auto;
        display: inline-block;
    }
    name-wrapper {
        float: left;
        line-height: 22px;
        letter-spacing: -1px;
        display: inline-block;
    }
    name-wrapper > h3 {
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .article-demonstrate {
        margin: 0 auto;
        min-width: 230px;
        display: table-caption;
        vertical-align: top;
    }
    .demonstration {
        display: list-item;
        text-align: -webkit-match-parent;
        margin-top: 10px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
        vertical-align: top;
    }
    .average {
        display: list-item;
        text-align: -webkit-match-parent;
        margin-top: 30px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
        vertical-align: top;
    }
    .score-table {
        width: 100%;
        margin: 30px auto;
        display: inline-block;
    }
    .pagination{
        display: inline-block;
        width: 880px;
    }
    .write-buttons > button {
        float: right;
    }
</style>